<!--
  @description 环境权限管理
  @author xiehan
  @date 2018/11/14
-->
<template>
  <div class="envauthority__content">
    <div style="margin-bottom: 10px;">
      <el-button type="primary" @click="addAuthority" v-g-rac="gRac('envauthority@add')" v-text="$t('common.add')"></el-button>
      <el-button type="primary" @click="deleteAuthority" v-g-rac="gRac('envauthority@delete')" v-text="$t('common.delete')"></el-button>
    </div>
    <el-form ref="searchForm" :model="searchForm" :inline="true" input-width="auto">
      <el-form-item :label="$t('envauthority.group')">
        <el-input v-model="searchForm.group"></el-input>
      </el-form-item>
      <el-form-item :label="$t('envauthority.user')">
        <el-input v-model="searchForm.name"></el-input>
      </el-form-item>
      <el-form-item :label="$t('envauthority.operator')">
        <el-input v-model="searchForm.operator"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" 
          @click="searchAuthority(true)" 
          v-g-rac="gRac('envauthority@search')" 
          v-text="$t('common.search')"></el-button>
      </el-form-item>
    </el-form>
    <el-table-extend 
      :data="tData" 
      :head="tableHead" 
      :selection="true" 
      :selectionChange="envSelect"
      :currentChange="currentChange"
      :sizeChange="sizeChange"
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('envauthority.table.operate')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import envauthorityBiz from '@/logic/continuousDelivery/envauthorityBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [rac, dic, table],
    data () {
      return {
        searchForm: {
          group: '',
          name: '',
          operator: ''
        },
        select_envType: {},
        tableHead: [],
        tableSelect: [],
        currentPage: 1,
        perPageCount: 10,
        tableControl: [{
          rac: () => this.gRac('envauthority@amend'),
          label: this.$t('common.edit'),
          callback: (row, index, data) => {
            this.$router.push({ name: 'handlerEnvauthority', query: { id: row.id } })
          }
        }]
      }
    },
    methods: {
      initTable () {
        this.tableHead = [{
          key: 'group',
          label: this.$t('envauthority.table')['group']
        }, {
          key: 'name',
          label: this.$t('envauthority.table')['name']
        }, {
          key: 'type',
          label: this.$t('envauthority.table')['type'],
          formatter: 'Dictionary',
          formatterDic: this.select_envType
        }, {
          key: 'operator',
          label: this.$t('envauthority.table')['operator']
        }, {
          key: 'updateTime',
          label: this.$t('envauthority.table')['updateTime']
        }]
      },
      async waitType () {
        await this.dGetDictionaryByCode('envauthtype')
        this.select_envType = { ...this.dDictionary.envauthtype }
        this.initTable()
        this.searchAuthority()
      },
      searchAuthority (fromClick = false) {
        if (fromClick) {
          this.currentPage = 1
          this.perPageCount = 10
        }
        let searchObj = {
          currentPage: this.currentPage,
          perPageCount: this.perPageCount
        }
        Object.keys(this.searchForm).map((item) => {
          if (this.searchForm[item]) {
            searchObj[item] = this.searchForm[item]
          }
        })
        envauthorityBiz.findEnvAuthority(searchObj).then((data) => {
          if (data && data.dataList) {
            data.dataList.map((item) => {
              item.updateTime = TimeFormat.getFormatTime(item.updateTime)
            })
          }
          this.tData = data
        })
      },
      addAuthority () {
        this.$router.push({ name: 'handlerEnvauthority' })
      },
      deleteAuthority () {
        let deleteArr = this.tableSelect.map(item => item.id)
        if (deleteArr.length === 0) {
          this.$message({
            message: this.$t('envauthority.selectTips'),
            type: 'warning'
          })
          return
        }
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          envauthorityBiz.delete({ ids: deleteArr }).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.searchAuthority()
          })
        }).catch(() => {})
      },
      envSelect (val) {
        this.tableSelect = val
      },
      currentChange (val) {
        this.currentPage = val
        this.searchAuthority()
      },
      sizeChange (val) {
        this.currentPage = 1
        this.perPageCount = val
        this.searchAuthority()
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'envauthority' && from.name === 'handlerEnvauthority') {
          this.waitType()
        }
      }
    },
    mounted () {
      this.waitType()
    }
  }
</script>

<style scoped>

</style>